import React from 'react';
import { FloatingPhone } from '../components/FloatingPhone';
import { EmergencyHeader } from '../components/EmergencyHeader';
import { CarRental } from '../components/CarRental';
import { TrustBadges } from '../components/TrustBadges';
import { SocialProof } from '../components/SocialProof';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
interface LandingPageProps {
  lang: string;
}
export function LandingPage({
  lang
}: LandingPageProps) {
  return <div className="min-h-screen bg-brand-black w-full overflow-x-hidden" data-id="element-118">
      <FloatingPhone lang={lang} data-id="element-119" />
      <main data-id="element-120">
        <EmergencyHeader lang={lang} data-id="element-121" />
        <CarRental lang={lang} data-id="element-122" />
        <TrustBadges lang={lang} data-id="element-123" />
        <SocialProof lang={lang} data-id="element-124" />
        <FinalCTA lang={lang} data-id="element-125" />
      </main>
      <Footer lang={lang} data-id="element-126" />
    </div>;
}